import { render } from "./EditBusinessRuleActionSendHttpRequest.vue?vue&type=template&id=f89e8e40"
import script from "./EditBusinessRuleActionSendHttpRequest.vue?vue&type=script&lang=js"
export * from "./EditBusinessRuleActionSendHttpRequest.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__